<template>
  <div>
    <v-scroll-y-transition group>
      <v-snackbar v-for="(snackBar, index) in snackBars" :key="index" v-model="snackBar.show" :timeout="6000"
                  bottom class="mt-5 mb-5" transition="scroll-y-transition">
        <v-icon :color="snackBar.color" class="pr-6">{{ snackBar.icon }}</v-icon>
        <span>{{ snackBar.message }}</span>
        <template v-slot:action="{ attrs }">
          <v-btn color="primary" text v-bind="attrs" @click="closeSnackBar(index)">Close</v-btn>
        </template>
      </v-snackbar>
    </v-scroll-y-transition>
  </div>
</template>
<script>
import {EventBus} from "@/lib/event-bus";
import {EVENTBUS_TOPICS} from "@/lib/constants";

export default {
  name: "user-action-result-popup",
  data() {
    return {
      actionResultDetailsList: [],
      snackBars: [],
      snackBar: {message: '', icon: 'mdi-check-circle', color: 'green', show: false},
    };
  },
  methods: {
    closeSnackBar(index) {
      this.snackBars[index].show = false;
    }
  },
  mounted() {
    EventBus.$on(EVENTBUS_TOPICS.USER_ACTION_FEEDBACK, (actionResultDetails) => {
      this.snackBars = this.snackBars.filter(snackBar => snackBar.show === true);
      this.snackBars.push({
        message: actionResultDetails.message,
        icon: actionResultDetails.isSuccess ? 'mdi-check-circle' : 'mdi-alert-circle',
        color: actionResultDetails.isSuccess ? 'green' : 'red',
        show: true
      });
    });
  },
  beforeDestroy() {
    EventBus.$off(EVENTBUS_TOPICS.USER_ACTION_FEEDBACK);
  },
};
</script>
<style scoped>
</style>
